/**
 * Adding p tag to slider text on Firefox the text is blurry without p tag.
 */
export function wrapText(){
    $ = jQuery;
    let sliderElement = ".slide-entry-excerpt";
    $(sliderElement).wrapInner("<p></p>");
}


// WEBPACK FOOTER //
// ./assets/ts/src/helpers/textSliderWrap.ts